<template>
 <div class="app-container">
   <el-tabs v-model="activeName" @tab-click="handleTabClick">
    <el-tab-pane label="中物系" name="0"> </el-tab-pane>
    <el-tab-pane label="兴瀚系" name="1"> </el-tab-pane>
  </el-tabs>
   <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="80px" size="mini" style="width: 100%;">
      <div class="formItemBox">
        <el-form-item label="子公司:">
           <el-select  v-model="searchForm.createSubcompanyCode" filterable placeholder="请选择" @change="fzgsChange">
              <el-option v-for="item in zigsList" :label="item.companyName" :value="item.companyCode" :key="item.id"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="部门名称:">
           <el-select  v-model="searchForm.createDepartmentCode" filterable placeholder="请选择" >
                <el-option v-for="item in FZbumenList" :label="item.name" :value="item.code" :key="item.id"></el-option>
              </el-select>
        </el-form-item>
        <el-form-item label="年月:">
           <el-select  v-model="searchForm.cycleMasterIds" filterable placeholder="请选择" @change="yueChange" multiple >
                <el-option v-for="item in yueList" :label="item.yearMonthDate" :value="item.id" :key="item.id"></el-option>
              </el-select>
        </el-form-item>
        <el-form-item label="周:">
           <el-select  v-model="searchForm.zhouIds" filterable placeholder="请选择" multiple >
              <el-option v-for="item in zhouList" :label="item.cycleName+'（'+item.startMonth.substring(5)+'至'+item.endMonth.substring(5)+'）'" :value="item.cycleDetailId" :key="item.cycleDetailId"></el-option>
            </el-select>
        </el-form-item>
      </div>
       <div class="searchBtnBox" style="margin: 0;">
         <el-form-item >
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item >
         <el-form-item >
           <el-button type="primary" @click="resetForm('searchForm')">重置</el-button>
         </el-form-item>
         <el-form-item v-if="btnFlg[4]">
           <el-button type="primary" @click="daochuFn" :disabled='isDisable'>导出</el-button>
          </el-form-item>
         <el-form-item v-if="btnFlg[1]">
           <el-button type="primary" @click="weihuFn">总额维护</el-button>
         </el-form-item>
        <!-- <el-form-item v-if="btnFlg[2]">
           <el-button type="primary" @click="shijishouzhiFn">实际收支</el-button>
         </el-form-item>
         <el-form-item v-if="btnFlg[3]">
           <el-button type="primary" @click="tiaozhengFn">调整</el-button>
         </el-form-item> -->

         <el-form-item >
           <p class="margin0">计划收入合计:<span class="red">{{totalJson.value3Sum}}</span>万元</p>
          </el-form-item>
           <el-form-item >
           <p class="margin0">计划支出合计:<span class="red">{{totalJson.value4Sum}}</span>万元</p>
          </el-form-item>
           <el-form-item >
           <p class="margin0">实际收入合计:<span class="red">{{totalJson.value12Sum}}</span>万元</p>
          </el-form-item>
           <el-form-item >
           <p class="margin0">实际支出合计:<span class="red">{{totalJson.value13Sum}}</span>万元</p>
          </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
   <div class="table" :style="{height:h}">
     <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  height="100%" style="width: 100%" center border highlight-current-row
     :row-style="setRowStyle" @row-click="handleRowClick">
       <el-table-column  type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column width="120" label="操作">
          <template slot-scope="scope">
            <div>
               <el-button type="text" size="mini" @click="shijishouzhiFn(scope.row)"  v-if="btnFlg[2]&&scope.row.sumFlag == '0'">实际收支</el-button>
                <el-button type="text" size="mini" @click="tiaozhengFn(scope.row)" v-if="btnFlg[3]&&scope.row.sumFlag == '0'">调整</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="value1" min-width="180" label="分子公司"></el-table-column>
        <el-table-column prop="value2" min-width="110" label="部门">
           <template slot-scope="scope">
              <div>
                <el-button type="text" size="mini" @click="bumenFn(scope.row)">{{ scope.row.value2 }}</el-button>
              </div>
            </template>
        </el-table-column>
        <el-table-column prop="value3" width="90" label="计划合计(万元)"> </el-table-column>
        <template v-for="item in tableHeadList">
          <el-table-column :key="item.valueKey" :label="item.name" :prop="item.valueKey" min-width="100">
          </el-table-column>
        </template>
         <el-table-column prop="value6" width="90" label="发生现金(万元)"> </el-table-column>
        <el-table-column prop="value8" width="90" label="发生承兑(万元)"> </el-table-column>
        <el-table-column prop="value10" width="90" label="发生现汇(万元)"></el-table-column>
        <el-table-column prop="value12" width="90" label="实际收支(万元)"> </el-table-column>
        <el-table-column prop="value14" width="90" label="偏差金额(万元)"></el-table-column>
        <el-table-column prop="planStatus" width="90" label="偏差率(%)">
          <template slot-scope="scope">
             <span >{{ scope.row.value16 }}%</span>
            </template>
        </el-table-column>

     </el-table>
   </div>
   <!-- 分页 -->
   <!-- <div>
     <el-pagination background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searchForm.pageNo"
      :page-sizes="[25,50,100]"
      :page-size="searchForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
     </el-pagination>
   </div> -->
    <el-dialog  title="维护总额" :close-on-click-modal="false" :close-on-press-escape="false"  @close="closeDialog"  :visible.sync="addFlag" width="550px" center>
      <div>
        <el-form  :inline="true" :rules="rules"  ref="zongeForm" :model="zongeForm"  class="demo-form-inline jiaoyan"  label-width="130px"  size="mini"  >
          <el-form-item label="公司系别:"  class="width1">
            {{ zongeForm.gongsixibie }}
          </el-form-item>
          <br>
          <el-form-item label="月份:"  class="width1">
            {{ zongeForm.yueName }}
          </el-form-item>
          <br>
           <el-form-item label="周:"  class="width1">
            {{ zongeForm.zhouName }}
          </el-form-item>
           <br>
          <el-form-item label="可用现汇总额:" prop="kyxhAmount" class="jiage" >
            <el-input  placeholder=""  v-number-input.float="4"  maxlength="8" v-model="zongeForm.kyxhAmount"  ></el-input>
            <span class="danwei" >万元</span>
          </el-form-item>
           <br>
          <el-form-item label="可用承兑总额:" prop="kycdAmount" class="jiage" >
            <el-input  placeholder=""  v-number-input.float="4"  maxlength="8" v-model="zongeForm.kycdAmount"  ></el-input>
            <span class="danwei" >万元</span>
          </el-form-item>
           <br>
          <el-form-item label="不可立即变现资金:" prop="bkljbxAmount" class="jiage" >
            <el-input  placeholder=""  v-number-input.float="4"  maxlength="8" v-model="zongeForm.bkljbxAmount"  ></el-input>
            <span class="danwei" >万元</span>
          </el-form-item>
           <br>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addFlag = false">取 消</el-button>
        <el-button type="primary" @click="saveFn()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog  title="选择周" :close-on-click-modal="false" :close-on-press-escape="false"  @close="closeDialog"  :visible.sync="xuanZhouFlag" width="550px" center>
      <div>
        <el-form  :inline="true" :rules="rules"  ref="xuanZhouForm" :model="zongeForm"  class="demo-form-inline jiaoyan"  label-width="130px"  size="mini"  >
          <el-form-item label="周:">
            <el-select  v-model="xuanZhouForm.xuanZhouid" filterable placeholder="请选择"  >
                <el-option v-for="item in xuanZhouList" :label="item.cycleName+'（'+item.startMonth.substring(5)+'至'+item.endMonth.substring(5)+'）'" :value="item.cycleDetailId" :key="item.cycleDetailId"></el-option>
              </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="xuanZhouFlag = false">取 消</el-button>
        <el-button type="primary" @click="xuanZhousaveFn()">确 定</el-button>
      </span>
    </el-dialog>
     <weekPlanDialog v-if="dialogMonth" :dialogMonth.sync="dialogMonth" :rowData="rowData" :title="xzTitle" ></weekPlanDialog>
    <weekDetailDialog v-if="detailMark" :detailMark.sync="detailMark" :rowData="rowData" :title="xzTitle" ></weekDetailDialog>
 </div>
</template>
<script>
import { getBtn } from '@/utils/getButton'
import { findFundPlanCycleForToday, weeklyFundPlanReportForInOut, findFundPlanCycleList, weekMasterList, getAmountList, saveFundPlanCycleAmount, updateFundPlanCycleAmount } from '@/api/common-signature'
import { getCurrUserDepartment, getCurrUserCompany } from '@/api/newCrm'
import { dateFormat1, dateTimeFormat, emptyFn, toFixed } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import weekDetailDialog from '@/views/common-signature/fundingPlan/public/weekDetailDialog.vue'
import weekPlanDialog from '@/views/common-signature/fundingPlan/public/weekPlanDialog.vue'
export default {
  components: { weekDetailDialog, weekPlanDialog },
  data () {
    return {
      activeName: '0',
      toFixed: toFixed,
      dateTimeFormat: dateTimeFormat,
      h: '500px',
      searchForm: {
        pageNo: 1,
        pageSize: 50
      },
      totalJson: {},
      loading: false,
      tableList: [],
      userCode: localStorage.getItem('userCode'),
      isDisable: false,
      zigsList: [],
      yueList: [],
      zhouList: [],
      FZbumenList: [],
      tableHeadList: [],
      cycleMasterId: null,
      detailMark: false,
      rowData: {},
      zongeForm: {},
      addFlag: false,
      rules: {
        kyxhAmount: [
          { required: true, message: '请输入可用现汇总额', trigger: 'blur' }
        ],
        kycdAmount: [
          { required: true, message: '请输入可用承兑总额', trigger: 'blur' }
        ],
        bkljbxAmount: [
          { required: true, message: '请输入不可立即变现资金', trigger: 'blur' }
        ]
      },
      dialogMonth: false,
      xzTitle: {},
      xuanRow: null,
      xuanZhouList: [],
      xuanZhouForm: {},
      xuanZhouFlag: false,
      btnFlg: [],
      btnIdArr: ['00FM0V0100', '00FM0V0200', '00FM0V0300', '00FM0V0400', '00FM0V0500']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/weeklyPlanSummary')
    getCurrUserCompany().then(res => { this.zigsList = res })
  },
  mounted () {
    findFundPlanCycleForToday().then(res => {
      this.yueList = res.cycleMasterList
      this.$set(this.searchForm, 'cycleMasterIds', [res.cycleMasterId])
      this.$set(this.searchForm, 'zhouIds', [res.cycleDetailId])
      this.$set(this.searchForm, 'tenantFaction', this.activeName == 1 ? 1 : 0)

      this.cycleMasterId = [res.cycleMasterId]
      findFundPlanCycleList({ cycleMasterIds: [res.cycleMasterId] }).then(res1 => {
        this.zhouList = res1
        this.getList()
      })
    })
  },
  methods: {
    // 选周保存
    xuanZhousaveFn () {
      if (!this.xuanZhouForm.xuanZhouid) {
        this.$message.error('请先选择周')
      }
      let json = this.xuanZhouList.find(item => item.cycleDetailId == this.xuanZhouForm.xuanZhouid)
      this.xuanZhouForm.xuanZhouName = json.cycleName + '（' + json.startMonth.substring(6) + '至' + json.endMonth.substring(6) + '）'
      if (this.xuanZhouForm.laiyuan == 'bumen') {
        this.bumenjiekou(this.xuanRow, this.xuanZhouForm.xuanZhouid)
      }
      if (this.xuanZhouForm.laiyuan == 'tiaozheng') {
        this.tiaozhengjiekou(this.xuanZhouForm.xuanZhouid)
      }
      if (this.xuanZhouForm.laiyuan == 'shiji') {
        this.shijijiekou(this.xuanZhouForm.xuanZhouid)
      }
      this.xuanZhouFlag = false
    },
    // 导出
    async daochuFn (row) {
      this.isDisable = true
      let form = { ...this.searchForm }
      await exportExcel(
        this.global.smpName + '/tReportDataView/exportWeeklyFundPlanReportList',
        form,
        this.searchForm.tenantFaction == 1 ? '兴瀚系' : '中物系' + '周资金计划汇总'
      )
      this.isDisable = false
    },
    handleRowClick (row) {
      this.xuanRow = row
    },
    shijishouzhiFn (row) {
      // if (!this.xuanRow) {
      //   this.$message.error('请选择要操作的数据')
      //   return
      // }
      // if (this.xuanRow.sumFlag === '1') {
      //   this.$message.error('合计数据不能操作')
      //   return
      // }
      this.xuanRow = row
      if (this.searchForm.zhouIds.length == 1) {
        this.shijijiekou(this.searchForm.zhouIds[0])
      } else {
        this.xuanZhouFlag = true
        this.xuanZhouForm.laiyuan = 'shiji'
      }
    },
    shijijiekou (cycleDetailId) {
      weekMasterList({
        pageNo: 1,
        pageSize: 50,
        cycleDetailId: cycleDetailId,
        createDepartmentCode: this.xuanRow.createDepartmentCode
      }).then(res => {
        if (res.list.length > 0 && res.list[0].planStatus == 4) {
          this.rowData = res.list[0]
          this.dialogMonth = true
          this.xzTitle = '实际收支'
          this.rowData.isSJ = true // 表示是实际收支
          this.rowData.isTZ = false // 表示是是否调整
        } else {
          this.$message.error(this.xuanZhouForm.xuanZhouName + '暂无资金计划上报')
        }
      }).catch(err => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    tiaozhengFn (row) {
      // if (!this.xuanRow) {
      //   this.$message.error('请选择要操作的数据')
      //   return
      // }
      // if (this.xuanRow.sumFlag === '1') {
      //   this.$message.error('合计数据不能操作')
      //   return
      // }
      this.xuanRow = row
      if (this.searchForm.zhouIds.length == 1) {
        this.tiaozhengjiekou(this.searchForm.zhouIds[0])
      } else {
        this.xuanZhouFlag = true
        this.xuanZhouForm.laiyuan = 'tiaozheng'
      }
    },
    tiaozhengjiekou (cycleDetailId) {
      weekMasterList({
        pageNo: 1,
        pageSize: 50,
        cycleDetailId: cycleDetailId,
        createDepartmentCode: this.xuanRow.createDepartmentCode
      }).then(res => {
        if (res.list.length > 0 && res.list[0].planStatus == 4) {
          this.rowData = res.list[0]
          this.dialogMonth = true
          this.xzTitle = '调整'
          this.rowData.isTZ = true // 表示是是否调整
          this.rowData.isSJ = false // 表示是实际收支
        } else {
          this.$message.error(this.xuanZhouForm.xuanZhouName ? this.xuanZhouForm.xuanZhouName : '' + '暂无资金计划上报')
        }
      }).catch(err => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    weihuFn () {
      if (!this.searchForm.cycleMasterIds) {
        this.$message.error('请先选择年月')
        return
      }
      if (!this.searchForm.zhouIds) {
        this.$message.error('请先选择周')
        return
      }
      if (this.searchForm.zhouIds.length == 0) {
        this.$message.error('请先选择周')
        return
      }
      let gongsixibie = this.searchForm.tenantFaction == 1 ? '兴瀚系' : '中物系'
      // let jons = this.yueList.find(itme => itme.id == this.searchForm.cycleMasterId)
      // let yueName = jons.yearMonthDate
      // let jonszhou = this.zhouList.find(itme => itme.cycleDetailId == this.searchForm.cycleDetailId)
      // let zhouName = jonszhou.cycleName + '（' + jonszhou.startMonth.substring(8) + '-' + jonszhou.endMonth.substring(8) + '）'
      let json = this.getMInDateItem(this.zhouList, this.searchForm.zhouIds)
      let yueName = json.yearMonthDate
      let zhouName = json.cycleName + '（' + json.startMonth.substring(8) + '-' + json.endMonth.substring(8) + '）'
      getAmountList({ businessType: 1,
        businessTableId: json.cycleDetailId,
        tenantFaction: this.searchForm.tenantFaction }).then(res => {
        if (res) {
          this.zongeForm = res
          this.zongeForm.gongsixibie = gongsixibie
          this.zongeForm.yueName = yueName
          this.zongeForm.zhouName = zhouName
        } else {
          this.zongeForm = {
            gongsixibie: gongsixibie,
            yueName: yueName,
            zhouName: zhouName,
            tenantFaction: this.searchForm.tenantFaction,
            businessType: 1,
            businessTableId: json.cycleDetailId,
            kyxhAmount: 0,
            kycdAmount: 0,
            bkljbxAmount: 0

          }
        }
        this.addFlag = true
      })
    },
    saveFn () {
      this.$refs.zongeForm.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          if (this.zongeForm.id) {
            updateFundPlanCycleAmount(this.zongeForm).then(res => {
              loading.close()
              this.$message({
                message: '操作成功',
                type: 'success'
              })
              this.addFlag = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          } else {
            saveFundPlanCycleAmount(this.zongeForm).then(res => {
              loading.close()
              this.$message({
                message: '操作成功',
                type: 'success'
              })
              this.addFlag = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }
        } else {
          return false
        }
      })
    },
    closeDialog () {

    },
    setRowStyle ({ row, index }) {
      if (row.sumFlag === '1') {
        return {
          'font-weight': ' bold ', 'background-color': '#ccc'
        }
      }
      if (!row.sumFlag) {
        return {
          'font-weight': ' bold ', 'background-color': 'rgb(205 231 191)'
        }
      }
      return {}
    },
    handleTabClick () {
      this.$set(this.searchForm, 'tenantFaction', this.activeName == 1 ? 1 : 0)
      this.getList()
    },
    bumenFn (row) {
      this.xuanRow = row
      if (this.searchForm.zhouIds.length == 1) {
        this.bumenjiekou(row, this.searchForm.zhouIds[0])
      } else {
        this.xuanZhouFlag = true
        this.xuanZhouForm.laiyuan = 'bumen'
      }

      // this.$router.push({ name: 'weeklyFundPlan', query: { code: row.createDepartmentCode, zhouId: this.searchForm.cycleDetailId } })
    },
    bumenjiekou (row, cycleDetailId) {
      weekMasterList({
        pageNo: 1,
        pageSize: 50,
        cycleDetailId: cycleDetailId,
        createDepartmentCode: row.createDepartmentCode
      }).then(res => {
        if (res.list.length > 0 && res.list[0].planStatus == 4) {
          this.xzTitle = row.value2 + '-周计划详情'
          this.detailMark = true
          this.rowData = res.list[0]
          this.rowData.incomeExpenseType = row.incomeExpenseType
        } else {
          this.$message.error(this.xuanZhouForm.xuanZhouName ? this.xuanZhouForm.xuanZhouName : '' + '暂无资金计划上报')
        }
      })
        .catch(err => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            onClose () {
            }
          })
        })
    },
    // 选择月份
    yueChange (e) {
      findFundPlanCycleList({ cycleMasterIds: e }).then(res1 => {
        this.zhouList = res1
        this.$set(this.searchForm, 'zhouIds', [])
      })
    },
    // 选择分子公司
    fzgsChange (e) {
      getCurrUserDepartment({ compayCode: e }).then(res => { this.FZbumenList = res })
      this.$set(this.searchForm, 'createDepartmentCode', null)
    },
    // 查选
    searchFn () {
      this.getList()
    },
    getMInDateItem (mainList, selectedIds, type) {
      // 1. 过滤出选中的数据
      const selected = mainList.filter(item => selectedIds.includes(item.cycleDetailId))

      if (!selected.length) return []

      // 2. 按 startMonth 日期 从小到大排序（2025-05-07 格式）
      selected.sort((a, b) => {
        // 只需要把 a 和 b 互换位置即可
        return new Date(a.startMonth) - new Date(b.startMonth)
      })

      // 注意：你这里 tpye 应该是拼写错误，正确是 type
      if (type == 1) {
        return selected
      } else {
        return selected[0]
      }
    },
    // 获取列表
    getList () {
      if (!this.searchForm.cycleMasterIds) {
        this.$message.error('请先选择年月')
        return
      }
      if (!this.searchForm.zhouIds) {
        this.$message.error('请先选择周')
        return
      }
      if (this.searchForm.zhouIds.length == 0) {
        this.$message.error('请先选择周')
        return
      }
      this.xuanZhouList = this.getMInDateItem(this.zhouList, this.searchForm.zhouIds, 1)
      let json = this.getMInDateItem(this.zhouList, this.searchForm.zhouIds)
      getAmountList({ businessType: 1,
        businessTableId: json.cycleDetailId,
        tenantFaction: this.searchForm.tenantFaction }).then(res => {
        this.$set(this.searchForm, 'kyxhAmount', res ? res.kyxhAmount : 0)
        this.$set(this.searchForm, 'kycdAmount', res ? res.kycdAmount : 0)
        this.$set(this.searchForm, 'bkljbxAmount', res ? res.bkljbxAmount : 0)
        this.loading = true
        this.searchForm.cycleDetailIds = this.searchForm.zhouIds.toString()
        weeklyFundPlanReportForInOut(this.searchForm).then(res => {
          this.tableList = res.headList.concat(res.dataList.reverse())
          this.tableHeadList = res.titleList
          this.totalJson = res.sumMap
          this.$nextTick(() => {
            let h = this.$refs.searchBox.offsetHeight
            let pH = document.documentElement.clientHeight
            this.h = (pH - h - 188) + 'px'
          })
          this.loading = false
          this.xuanRow = null
        }).catch(err => {
          this.loading = false
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            onClose () {
            }
          })
        })
      }).catch(err => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    // 重置
    resetForm (formName) {
      this.cycleMasterId = this.searchForm.cycleMasterIds
      // debugger
      this.searchForm = {

      }
      this.$set(this.searchForm, 'cycleMasterIds', this.cycleMasterId)
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchForm.pageSize = val
      this.getList()
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchForm.pageNo = val
      this.getList()
    }

  }
}
</script>

<style scoped lang='less'>
 .formItemBox{
    /deep/.el-form-item{
      width: 24%;
    }
  }
</style>
